var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _vm.reminder
    ? _c(
        "div",
        {
          staticClass: "wkb-graph-reminder",
          attrs: { role: "status", "aria-label": _vm.reminder.message },
        },
        [
          _c(
            "button",
            {
              staticClass: "wkb-graph-reminder-close",
              attrs: { type: "button", "aria-label": "Close" },
              on: {
                click: function ($event) {
                  return _vm.$emit("dismiss")
                },
              },
            },
            [_vm._v(" × ")]
          ),
          _c("p", { staticClass: "wkb-graph-reminder-message" }, [
            _vm._v(_vm._s(_vm.reminder.message)),
          ]),
          _vm.actionButtons.length
            ? _c(
                "div",
                { staticClass: "wkb-graph-reminder-actions" },
                _vm._l(_vm.actionButtons, function (action) {
                  return _c(
                    "button",
                    {
                      key: action.id,
                      staticClass: "wkb-graph-reminder-btn",
                      class: { "is-primary": action.primary },
                      attrs: { type: "button" },
                      on: {
                        click: function ($event) {
                          return _vm.$emit("action", action.id)
                        },
                      },
                    },
                    [_vm._v(" " + _vm._s(action.label) + " ")]
                  )
                }),
                0
              )
            : _vm._e(),
        ]
      )
    : _vm._e()
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }